<template>
  <div ref="reference">
    <button
      type="button"
      class="-mx-1 flex size-[26px] cursor-pointer items-center justify-center rounded-[6px] text-gray-800 transition hover:bg-gray-200/25"
      @click="open = !open"
    >
      <MenuIcon class="size-[18px]" aria-hidden="true" />
    </button>

    <Teleport to="body">
      <div v-if="open" ref="floating" class="z-[999]" :style="floatingStyles">
        <Menu class="w-[160px]">
          <Menu.Item
            class="text-red-600!"
            :icon="TrashIcon"
            @click="handleRemove"
          >
            Remove
          </Menu.Item>
        </Menu>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { autoUpdate, flip, offset, shift, useFloating } from '@floating-ui/vue'
import { Menu } from '@dacr/library'
import { MenuIcon, TrashIcon } from '@dacr/icons'
import { useEventListener } from '@/shared/composables/useEventListener'

const emit = defineEmits<{ remove: [] }>()

const open = ref(false)
const reference = ref<HTMLElement>()
const floating = ref<HTMLElement>()

const { floatingStyles } = useFloating(reference, floating, {
  placement: 'bottom-end',
  whileElementsMounted: autoUpdate,
  middleware: [offset(6), flip({ padding: 8 }), shift({ padding: 8 })],
})

useEventListener(window, 'click', (event) => {
  const target = event.target as Node
  if (reference.value?.contains(target) || floating.value?.contains(target)) {
    return
  }
  open.value = false
})

const handleRemove = () => {
  open.value = false
  emit('remove')
}
</script>
